import {GameModel} from "@nolimitcity/slot-game/bin/model/GameModel";
import {BetClusterWinData, IDogFight, IFinalWave, PearlHarborGameData, PearlHarborInitData} from "./PearlHarborData";
import {ApiPlugin} from "@nolimitcity/slot-launcher/bin/plugins/ApiPlugin";
import {SYMBOL_NAME} from "../reels/PearlHarborSymbol";
import {PearlHarborGameMode} from "./PearlHarborGameMode";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {PearlHarborHelper} from "../utils/PearlHarborHelper";
import {PearlHarbor} from "../PearlHarbor";
import {PearlHarborSoundManager} from "../sound/PearlHarborSoundManager";
import {APIFeatureBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";

export interface ITargetArea {
    center: number[],
    reelSize: number,
    rowSize: number,
    actualReelSize: number,
    actualRowSize: number,
    reelStart: number,
    reelEnd: number,
    rowStart: number,
    rowEnd: number
}

export interface ISplitData {
    symPos: number[],
    dir: boolean[]
    multi: number
}

export interface IBigSymsResponse {
    multAfterSplit: number [],
    sizeReelAfterSplit: number [],
    sizeRowAfterSplit: number[],
    symbolsAfterSplit: string [],
    topLeftSeedAfterSplit: number [],
    multCollapse: number[];
    multLanding: number[];
    sizeReelCollapse: number[];
    sizeReelLanding: number[];
    sizeRowCollapse: number[];
    sizeRowLanding: number[];
    symbolsCollapse: string[];
    symbolsLanding: string[];
    topLeftSeedCollapse: number[];
    topLeftSeedLanding: number[];
}

export interface ISymbolData {
    symName: string,
    textureName: string,
    size: number[],
    sizeMultiplier: number,
    collapseY: number,
    isSplit: boolean,
    toCollapse?: boolean,
    isSpecial: boolean
    isBig: boolean
    bigMultiplier: number
    topLeftSeed: number
}

export class PearlHarborModel extends GameModel<PearlHarborInitData, PearlHarborGameData> {

    private _winRatio: number;
    public isNextNormal: boolean;
    public reels: string[][];
    public barriers: number[];
    public targetSymbolPos: number[];
    public xbombPos: number[][];
    public allWinPositions: boolean[][];
    public betClusterWins: BetClusterWinData[];
    public allSizesBeforeCollapse: number[][];
    public scatterCount: number = 0;
    public reelAfterCollapsePrevSpin: string[][] = [];
    public scatterPositions: number[][] = [];
    public explodePositions: boolean[][];
    public isRestore: boolean = false;
    public isNormal: boolean = false;
    public isRestoreFeatureBet: boolean;
    public buyFeatureName: string;

    public dogfight: IDogFight | IFinalWave;
    public xs: ISplitData[];
    public xsLanding: ISplitData[];
    public xsThisTurn: ISplitData[];

    public allSymbolsData: ISymbolData[][];
    public afterCollapseSymbolsData: ISymbolData[][];
    public afterSplitSymbolsData: ISymbolData[][];

    public multiplierNextSpin: number;
    public scatterMultiplier: number;
    public mainGameMultiHasBeenUsed: boolean;
    public bigSymsResponse: IBigSymsResponse;
    public allBigSymsTopLeftPositionsAfterSplits: number[];
    public buyFeatureScatters: number[];

    constructor(api: ApiPlugin, triggerEvents: boolean = true) {
        super(api, triggerEvents);
        api.events.once("featureBet", (data: boolean) => {
            this.isRestoreFeatureBet = data;
        });
        api.events.once("featureName", (data: string) => {
            this.buyFeatureName = data;
        });
        PearlHarbor.apiPlugin.events.on(APIEvent.BET, (betData: APIFeatureBetEventData) => {
            for (let index = 0; index < PearlHarbor.model.initData.featureBuyTimesBetValue.length; index++) {
                if (PearlHarbor.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    this.buyFeatureName = betData.featureName;
                    Logger.logDev("Opted Feature : ", this.buyFeatureName);
                    break;
                }
            }
        });

        PearlHarbor.apiPlugin.events.on(APIEvent.ACTION_SPINS_BET, (betData: APIFeatureBetEventData) => {
            for (let index = 0; index < PearlHarbor.model.initData.featureBuyTimesBetValue.length; index++) {
                if (PearlHarbor.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    this.buyFeatureName = betData.featureName;
                    Logger.logDev("Opted Feature : ", this.buyFeatureName);
                    break;
                }
            }
        });
    }

    private calculateScatters(reels: string[][], isInit: boolean = false): void {
        this.scatterCount = 0;
        this.scatterPositions = [];

        let nearWinReels: boolean[] = this.defaultNearWinReels();
        //if (this.data.mode === PearlHarborGameMode.NORMAL_AVALANCHE) {
        //    nearWinReels = this.calculateNearWinInAvalanche(reels, nearWinReels);
        //}

        reels.forEach((reel: string[], reelId: number) => {
            if (this.scatterCount >= 2 && reelId < 6) {
                nearWinReels[reelId] = true;
            }

            for (let rowId: number = 0; rowId < reel.length; rowId++) {
                if (reel[rowId] == SYMBOL_NAME.SCATTER) {
                    this.scatterPositions.push([reelId, rowId]);
                    this.scatterCount++;
                }
            }
        });
    }

    private parseSplitData(xSplit: any, xMulti: any): ISplitData[] {

        let xs: ISplitData[] = [];
        for (let key in xSplit) {
            let value = xSplit[key];
            xs.push({
                symPos: [Math.floor(parseInt(key) / 14), parseInt(key) % 14],
                dir: value,
                multi: !xMulti ? 1 : xMulti[key]
            })
        }
        return xs;
    }

    private addSymbolSizeOnInit(allSymbolsData: ISymbolData[][], symSizes: number[][]): ISymbolData[][] {
        allSymbolsData.forEach((allSymbolDataOnReel: ISymbolData[], i: number) => {
            allSymbolDataOnReel.forEach((symData: ISymbolData, j: number) => {
                symData.sizeMultiplier = symSizes[i][j];
            });

        });
        return allSymbolsData;
    }

    private initReelsHasSplitSymbol(reels: string[][]): string[][] {
        let addSpentOnXSReels: string[][] = ArrayHelper.initArrayWithValues(reels.length, (s: number) => {
                return ArrayHelper.initArrayWithValues(reels[s].length, (t: number) => reels[s][t]);
            }),
            hasSplitSymbol: boolean = false;

        addSpentOnXSReels.forEach((reel: string[]) => {
            reel.forEach((sym: string) => {
                if (sym === "X_SPLIT") {
                    hasSplitSymbol = true;
                    sym = "X_SPLIT_SPENT";
                } else if (sym === "X_SPLIT_H") {
                    hasSplitSymbol = true;
                    sym = "X_SPLIT_SPENT_H";
                }
            });
        });

        return (hasSplitSymbol ? addSpentOnXSReels : []);
    }

    private parseBigSymbols(bigSymData: IBigSymsResponse, symbolData: ISymbolData[][], afterCollapse: boolean): ISymbolData[][] {
        if (symbolData.length === 0) {
            return [];
        }
        const reels: ISymbolData[][] = symbolData.concat();
        (afterCollapse ? bigSymData.topLeftSeedCollapse : bigSymData.topLeftSeedLanding).forEach((topLeft: number, i) => {
            const reel: number = Math.floor(topLeft / 14),
                symTargetPosition: number = topLeft % 14,
                sizeReel: number = (afterCollapse ? bigSymData.sizeReelCollapse : bigSymData.sizeReelLanding)[i],
                sizeRow: number = (afterCollapse ? bigSymData.sizeRowCollapse : bigSymData.sizeRowLanding)[i],
                orgName: string = (afterCollapse ? bigSymData.symbolsCollapse : bigSymData.symbolsLanding)[i],
                symName: string = `${orgName}_${sizeReel}x${sizeRow}`,
                multi: number = (afterCollapse ? bigSymData.multCollapse : bigSymData.multLanding)[i];
            let symCount: number = 0;

            for (let s: number = 0; s < sizeReel; s++) {
                const reelId: number = reel + s;
                const symId: number = this.getOnReelId(symTargetPosition, reelId, afterCollapse ? this.reelAfterCollapsePrevSpin : this.reels);
                for (let t: number = 0; t < sizeRow; t++) {
                    if (orgName !== reels[reelId][symId + t].symName) {
                        debugger;
                        Logger.logDev("-------- not same big symbol on reels -----------")
                    }
                    reels[reelId][symId + t].textureName = `${symName}_${symCount}`;
                    reels[reelId][symId + t].size = [sizeReel, sizeRow];
                    reels[reelId][symId + t].isBig = true;
                    reels[reelId][symId + t].bigMultiplier = multi;
                    reels[reelId][symId + t].topLeftSeed = topLeft;
                    symCount++;
                }
            }
        });

        return reels;
    }

    private parseBigSymbolsAfterSplit(bigSymData: IBigSymsResponse, symbolData: ISymbolData[][], evaluatedArea: string[][]): ISymbolData[][] {
        const seeds: number[] = bigSymData.topLeftSeedAfterSplit ? bigSymData.topLeftSeedAfterSplit : bigSymData.topLeftSeedLanding;
        (seeds).forEach((topLeft: number, i) => {
            const reel: number = Math.floor(topLeft / 14),
                symTargetPosition: number = topLeft % 14,
                sizeReel: number = bigSymData.sizeReelAfterSplit[i],
                sizeRow: number = bigSymData.sizeRowAfterSplit[i],
                orgName: string = bigSymData.symbolsAfterSplit[i],
                symName: string = `${orgName}_${sizeReel}x${sizeRow}`,
                multi: number = bigSymData.multAfterSplit[i];
            let symCount: number = 0;

            for (let s: number = 0; s < sizeReel; s++) {
                const reelId: number = reel + s;
                const symId: number = this.getOnReelId(symTargetPosition, reelId, evaluatedArea);
                for (let t: number = 0; t < sizeRow; t++) {
                    if (orgName !== symbolData[reelId][symId + t].symName) {
                        debugger;
                        Logger.logDev("-------- not same big symbol on reels -----------")
                    }
                    symbolData[reelId][symId + t].textureName = `${symName}_${symCount}`;
                    symbolData[reelId][symId + t].size = [sizeReel, sizeRow];
                    symbolData[reelId][symId + t].isBig = true;
                    symbolData[reelId][symId + t].bigMultiplier = multi;
                    symbolData[reelId][symId + t].topLeftSeed = topLeft;
                    symCount++;
                }
            }
        });

        return symbolData;
    }

    private parseSymbolData(reels: string[][], allSize: number[][] = []): ISymbolData[][] {
        const allSymbolsData: ISymbolData[][] = [];
        let symSizes: number[][] = this.allSizesBeforeCollapse ? this.allSizesBeforeCollapse : [];
        if (allSize.length > 0) {
            symSizes = allSize;
        }
        for (let i: number = 0; i < reels.length; i++) {
            const reelSymbolData: ISymbolData[] = [];
            let toY: number = 0;
            for (let j: number = 0; j < reels[i].length; j++) {
                const symName: string = reels[i][j],
                    isHalf: boolean = (symName.indexOf("_H") > -1),
                    size = (symSizes.length > 0 ? symSizes[i][j] : 1),
                    symData: ISymbolData = {
                        symName: symName,
                        textureName: symName,
                        size: [1, isHalf ? 0.5 : 1],
                        collapseY: toY - (isHalf ? 24 : 0),
                        sizeMultiplier: (this.isReTriggerMode() || this.isRestore) ? size : 1,
                        bigMultiplier: -1,
                        topLeftSeed: -1,
                        isSplit: isHalf,
                        isBig: false,
                        isSpecial: PearlHarborHelper.isSpecialSymbol(symName)
                    };
                toY += (isHalf ? 48 : 96);
                reelSymbolData.push(symData);
            }
            allSymbolsData.push(reelSymbolData);
        }
        return allSymbolsData;
    }

    private parseAfterCollapseSymbolData(reels: string[][], allSize: number[][] = []): ISymbolData[][] {
        const symbolsData: ISymbolData[][] = [];
        let symSizes: number[][] = this.allSizesBeforeCollapse ? this.allSizesBeforeCollapse : [];
        if (allSize.length > 0) {
            symSizes = allSize;
        }
        for (let i: number = 0; i < reels.length; i++) {
            let collapseY: number = 7 * 96;
            const reelSymbolData: ISymbolData[] = [];
            for (let j: number = (reels[i].length - 1); j > -1; j--) {
                const symName: string = reels[i][j],
                    isHalf: boolean = (symName.indexOf("_H") > -1),
                    size = (symSizes.length > 0 ? symSizes[i][j] : 1);
                collapseY -= (isHalf ? 48 : 96);

                reelSymbolData.push({
                    symName: symName,
                    textureName: symName,
                    collapseY: collapseY - (isHalf ? 24 : 0),
                    size: [1, isHalf ? 0.5 : 1],
                    sizeMultiplier: size,
                    bigMultiplier: -1,
                    topLeftSeed: -1,
                    isSplit: isHalf,
                    isBig: false,
                    isSpecial: PearlHarborHelper.isSpecialSymbol(symName)
                });
            }
            symbolsData.push(reelSymbolData.reverse());
        }
        return symbolsData;
    }

    /*
        private parseReelsEnteringFreespinSymbolData(initialReel: string[][],reelsEnteringFreespin: string[][], allSize:number[][] = []): ISymbolData[][] {
            const allSymbolsData: ISymbolData[][] = [];
            let symSizes:number[][] = allSize,
                reels:string[][] = ArrayHelper.initArrayWithValues(reelsEnteringFreespin.length,(s:number)=>{
                    return ArrayHelper.initArrayWithValues(reelsEnteringFreespin[s].length, (t:number)=>reelsEnteringFreespin[s][t]);
                });

            for (let i: number = 0; i < reelsEnteringFreespin.length; i++) {
                const reelSymbolData: ISymbolData[] = [];
                let toY: number = 0,
                    onReelId: number = 0,
                isSame:boolean=true;
                for (let j: number = 0; j < reelsEnteringFreespin[i].length; j++) {
                    let symName: string = reelsEnteringFreespin[i][j];
                    const isHalf: boolean = (symName.indexOf("_H") > -1);
                    if(reels[i][Math.floor(onReelId)] != reelsEnteringFreespin[i][j]){
                        symName = reels[i][Math.floor(onReelId)]+(isHalf?"_H":"");
                        isSame = false;
                    }
                    const size = (symSizes.length>0?symSizes[i][j] : 1),
                        symData: ISymbolData = {
                            symName: symName,
                            textureName: symName,
                            size: [1, isHalf ? 0.5 : 1],
                            collapseY: toY - (isHalf ? 24 : 0),
                            sizeMultiplier: (this.isReTriggerMode()||this.isRestore) ? size : 1,
                            bigMultiplier: -1,
                            topLeftSeed: -1,
                            isSplit: isHalf,
                            isBig: false,
                            isSpecial: PearlHarborHelper.isSpecialSymbol(symName)
                        };
                    toY += (isHalf ? 48 : 96);
                    onReelId += ((isHalf&&!isSame)?0.5:1);
                    reelSymbolData.push(symData);
                }
                allSymbolsData.push(reelSymbolData);
            }
            debugger
            return allSymbolsData;
        }
    */

    private parseSymbolsAfterSplitData(eva: string[][], reels: string[][]): ISymbolData[][] {
        const symbolsData: ISymbolData[][] = [];
        for (let reelId: number = 0; reelId < eva.length; reelId++) {
            const reelSymbolData: ISymbolData[] = [];
            let collapseY: number = 7 * 96,
                splitOnReelId: number = eva[reelId].length - 1;
            for (let j: number = (reels[reelId].length - 1); j > -1; j--) {
                let isOrgHalf: boolean = reels[reelId][j].indexOf("_H") > -1,
                    newSymName: string = eva[reelId][splitOnReelId],
                    isHalf: boolean = (newSymName.indexOf("_H") > -1),
                    size = this.allSizesBeforeCollapse ? this.allSizesBeforeCollapse[reelId][splitOnReelId] : 1;
                collapseY -= (isHalf ? 48 : 96);
                if (newSymName === "X") {
                    newSymName = reels[reelId][j];
                } else if (newSymName === "X_H" && isOrgHalf) {
                    newSymName = reels[reelId][j];
                } else if (newSymName === "X_H" && !isOrgHalf) {
                    newSymName = reels[reelId][j] + "_H";
                }
                reelSymbolData.push({
                    symName: newSymName,
                    textureName: newSymName,
                    collapseY: collapseY - (isHalf ? 24 : 0),
                    size: [1, isHalf ? 0.5 : 1],
                    sizeMultiplier: size,
                    bigMultiplier: -1,
                    topLeftSeed: -1,
                    isSplit: isHalf,
                    isBig: false,
                    isSpecial: PearlHarborHelper.isSpecialSymbol(newSymName)
                });
                splitOnReelId--;
                if (!isOrgHalf && isHalf) {
                    newSymName = eva[reelId][splitOnReelId];
                    isHalf = (newSymName.indexOf("_H") > -1);
                    size = this.allSizesBeforeCollapse ? this.allSizesBeforeCollapse[reelId][splitOnReelId] : 1;
                    collapseY -= (isHalf ? 48 : 96);
                    if (newSymName === "X") {
                        newSymName = reels[reelId][j];
                    } else if (newSymName === "X_H" && isOrgHalf) {
                        newSymName = reels[reelId][j];
                    } else if (newSymName === "X_H" && !isOrgHalf) {
                        newSymName = reels[reelId][j] + "_H";
                    }
                    reelSymbolData.push({
                        symName: newSymName,
                        textureName: newSymName,
                        collapseY: collapseY - (isHalf ? 24 : 0),
                        size: [1, isHalf ? 0.5 : 1],
                        sizeMultiplier: size,
                        bigMultiplier: -1,
                        topLeftSeed: -1,
                        isSplit: isHalf,
                        isBig: false,
                        isSpecial: PearlHarborHelper.isSpecialSymbol(newSymName)
                    });
                    splitOnReelId--;
                }
            }
            symbolsData.push(reelSymbolData.reverse());
        }
        return symbolsData;
    }

    private parseTargetSymbolData(reels: string[][]): number[] {
        for (let i: number = 0; i < reels.length; i++) {
            for (let j: number = 0; j < reels[i].length; j++) {
                if (reels[i][j] === SYMBOL_NAME.TARGET || reels[i][j] === SYMBOL_NAME.TARGET_H) {
                    return [i, j];
                }
            }
        }
        return [];
    }

    private parseXBombData(evaluatedArea: string[][], isInit: boolean = false): void {
        this.xbombPos = [];
        if (isInit) {
            return;
        }
        let row: number = 0;

        for (let i: number = 0; i <= 6; i++) {
            row = 0;
            for (let j: number = 0; j < evaluatedArea[i].length; j++) {
                if (evaluatedArea[i][j] === SYMBOL_NAME.BOMB) {
                    this.xbombPos.push([i, j]);
                }
                row += (PearlHarborHelper.isHalfSymbol(evaluatedArea[i][j]) ? 1 : 2);
            }
        }
    }

    private parseWinData(clusterWins: BetClusterWinData[], evaluatedArea: string[][]): BetClusterWinData[] {
        if (!clusterWins) {
            return [];
        }

        let wins = clusterWins.concat();
        wins.forEach((win: BetClusterWinData) => {
            let startReel: number = -1;
            win.reelWinPositions.forEach((reelWin: boolean[], i: number) => {
                const hasWon: boolean = (reelWin.indexOf(true) > -1);
                startReel = (startReel === -1) ? (hasWon ? i : -1) : startReel;
            });
            win.startReel = startReel;
        });
        return <BetClusterWinData[]>wins;
    }

    private getOnReelId(reelTargetPosition: number, reelId: number, reels: string[][]): number {
        let onReelId: number = -1;
        for (let i: number = 0; i <= reelTargetPosition; i++) {
            onReelId++;
            i += (PearlHarborHelper.isHalfSymbol(reels[reelId][onReelId]) ? 0 : 1);
        }
        return onReelId;
    }

    private defaultNearWinReels(): boolean[] {
        return [false, false, false, false, false, false, false];
    }

    private isNonActivePos(i: number, j: number): boolean {
        if (i < 2 || i > 4) {
            return true;
        }

        if (j < 2 || j > 4) {
            return true;
        }
        return false;
    }

    private getSecondBuyFeatureScatter(reels: string[][]): number {

        if (!PearlHarbor.foregroundElements.boostedBet) {
            return -1;
        }
        for (let i: number = 0; i <= 6; i++) {
            for (let j: number = 0; j < reels[i].length; j++) {
                if (this.isNonActivePos(i, j) && reels[i][j] === SYMBOL_NAME.SCATTER) {
                    return (i * 14 + j * 2);
                }
            }
        }
        debugger;

        return -1;
    }

    private isNormalMode(mode: string): boolean {
        return mode === GameMode.NORMAL || mode === PearlHarborGameMode.NORMAL_AVALANCHE;
    }

    protected onInit(data: PearlHarborInitData): void {
        super.onInit(data);

        this.isRestore = data.isRestoreState;
        this.isNormal = this.isNormalMode(data.mode);
        this.isNextNormal = this.isNormalMode(data.nextMode);

        this.barriers = data.barriers;
        this.multiplierNextSpin = data.currentMultiplier;
        this.mainGameMultiHasBeenUsed = false;
        this.scatterMultiplier = 0;
        if ((data.mode === GameMode.FREESPIN || data.nextMode === GameMode.FREESPIN)) {
            this.dogfight = data.dogfight!;
        } else if ((data.mode === PearlHarborGameMode.SUPER_FREESPIN || data.nextMode === PearlHarborGameMode.SUPER_FREESPIN)) {
            this.dogfight = data.finalWave!;
        }

        if (data.xSplits) {
            this.xs = this.parseSplitData(data.xSplits, data.xsplitsMultipliers);
        }

        if (this.isNormal) {
            this.reels = data.reels;
            this.calculateScatters(data.reels, true);
            this.allSizesBeforeCollapse = data.allSizesBeforeCollapse;
            this.reelAfterCollapsePrevSpin = data.reelsAfterCollapse;
            this.allSymbolsData = this.parseSymbolData(data.isRestoreState ? data.reelsAfterCollapse : this.reels, data.allSize ? data.allSize : []);
            this.afterCollapseSymbolsData = ((data.nextMode === PearlHarborGameMode.NORMAL_AVALANCHE) ? this.parseAfterCollapseSymbolData(data.reelsAfterCollapse, data.allSize ? data.allSize : []) : []);
            if (data.bigSymPresent) {
                this.bigSymsResponse = data.bigSymResponse;
                this.allSymbolsData = this.parseBigSymbols(this.bigSymsResponse, this.allSymbolsData, data.isRestoreState);
                this.afterCollapseSymbolsData = this.parseBigSymbols(this.bigSymsResponse, this.afterCollapseSymbolsData, true);
            }
            if (data.freespinTriggeredThisSpin) {
                this.scatterMultiplier = Math.max(0, this.dogfight.initialMultFromTrigger / data.currentMultiplier);
            }
            this.targetSymbolPos = this.parseTargetSymbolData(data.reels);
            this.parseXBombData(this.reels, true);
        } else {
            this.reels = data.reels;
            this.calculateScatters(data.reelsEnteringFreespin, true);
            this.allSymbolsData = this.parseSymbolData(this.reels, data.allSize ? data.allSize : []);
            //this.allSymbolsData = (data.isRestoreState ? this.parseReelsEnteringFreespinSymbolData(data.reelsEnteringFreespin) : []);
            if (data.bigSymPresent) {
                this.bigSymsResponse = data.bigSymResponse;
                this.allSymbolsData = this.parseBigSymbols(this.bigSymsResponse, this.allSymbolsData, false);
            }
            this.scatterMultiplier = Math.max(0, this.dogfight.initialMultFromTrigger / this.multiplierNextSpin);
            this.mainGameMultiHasBeenUsed = this.dogfight.totalMult > 1;
        }

        if (data.isRestoreState && !this.isNextNormal) {
            const addSpentOnXSReels: string[][] = this.initReelsHasSplitSymbol(data.reels);
            this.allSymbolsData = ((addSpentOnXSReels.length > 0) ? this.parseSymbolsAfterSplitData(data.reelsEnteringFreespin, addSpentOnXSReels) : this.allSymbolsData);
            if (data.bigSymPresent && (addSpentOnXSReels.length > 0)) {
                this.afterSplitSymbolsData = this.parseBigSymbolsAfterSplit(data.bigSymResponse, this.allSymbolsData, data.reelsEnteringFreespin);
            }
            this.addSymbolSizeOnInit(this.allSymbolsData, data.allSize);
        }
        this.buyFeatureScatters = [];
    }

    public onGame(data: PearlHarborGameData): void {
        super.onGame(data);
        if (PearlHarbor.isActionSpinsActive){
            return;
        }
        this.isNormal = this.isNormalMode(data.mode);
        this.isNextNormal = this.isNormalMode(data.nextMode);
        this.scatterMultiplier = 0;
        this.buyFeatureScatters = [];
        if ((data.mode === GameMode.FREESPIN || data.nextMode === GameMode.FREESPIN)) {
            this.dogfight = data.dogfight!;
        } else if ((data.mode === PearlHarborGameMode.SUPER_FREESPIN || data.nextMode === PearlHarborGameMode.SUPER_FREESPIN)) {
            this.dogfight = data.finalWave!;
        }

        if (data.freespinTriggeredThisSpin) {
            this.scatterMultiplier = Math.max(this.dogfight.initialMultFromTrigger / data.multiplierNextSpin, 0);
            this.mainGameMultiHasBeenUsed = false;
        }

        if (this.isNormal) {
            this.multiplierNextSpin = data.multiplierNextSpin;
            this.barriers = data.barriers2Delete;
            this.allSizesBeforeCollapse = data.allSizesBeforeCollapse;
            this.reels = data.reels.concat();
            this.reelAfterCollapsePrevSpin = data.reelsAfterCollapse;
            this.allWinPositions = data.allWinPositions;
            this.allSymbolsData = this.parseSymbolData(this.reels);
            this.afterCollapseSymbolsData = ((data.nextMode === PearlHarborGameMode.NORMAL_AVALANCHE) ? this.parseAfterCollapseSymbolData(data.reelsAfterCollapse) : []);
            this.xsThisTurn = this.parseSplitData(data.xsplitsTriggeredThisTurn, data.xsplitsMultipliersWhenLanding);
            this.afterSplitSymbolsData = ((this.xsThisTurn.length > 0) ? this.parseSymbolsAfterSplitData(data.evaluatedArea, this.reels) : []);
            if (data.bigSymPresent) {
                this.bigSymsResponse = data.bigSymsResponse;
                this.allSymbolsData = this.parseBigSymbols(data.bigSymsResponse, this.allSymbolsData, false);
                this.afterCollapseSymbolsData = this.parseBigSymbols(data.bigSymsResponse, this.afterCollapseSymbolsData, true);
                if (this.afterSplitSymbolsData.length > 0) {
                    this.afterSplitSymbolsData = this.parseBigSymbolsAfterSplit(data.bigSymsResponse, this.afterSplitSymbolsData, data.evaluatedArea);
                }
            }
            this.betClusterWins = this.parseWinData(data.betClusterWins, data.evaluatedArea);
            this.parseXBombData(data.evaluatedArea, false);
            this._winRatio = data.accumulatedRoundWin / data.playedBetValue;
            this.targetSymbolPos = this.parseTargetSymbolData(this.reels);
            this.xsLanding = this.parseSplitData(data.xSplitsWhenLanding, data.xsplitsMultipliersWhenLanding);
            this.xs = this.parseSplitData(data.xSplits, data.xsplitsMultipliers);
            this.explodePositions = data.explodePositions;
            this.calculateScatters(data.evaluatedArea);
            if (PearlHarbor.foregroundElements.boostedBet && data.mode === GameMode.NORMAL) {
                this.buyFeatureScatters.push(48);
                this.buyFeatureScatters.push(this.getSecondBuyFeatureScatter(data.reels));
            }
        }
        this.isRestore = false;
        PearlHarbor.bigWinPlayed = false;
        PearlHarborSoundManager.resetSoundsOnGameData();
    }

    public isReTriggerMode(): boolean {
        return (this.data.mode.indexOf("_AVALANCHE") > -1);
    }

    public isWinThisRound(): boolean {
        return !!this.gameData.betClusterWins.length;
    }

    public get winRatio(): number {
        return this._winRatio;
    }

    public set winRatio(value: number) {
        this._winRatio = value;
    }
}